var map = {
	"./A.svg": 65850,
	"./B.svg": 45275,
	"./C.svg": 68784,
	"./D.svg": 41965,
	"./N.svg": 9836,
	"./NP.svg": 15903,
	"./NR.svg": 15268,
	"./O.svg": 97890,
	"./PNC.svg": 51988,
	"./POP.svg": 12971,
	"./R.svg": 92905,
	"./V.svg": 36030,
	"./current.svg": 11104,
	"./unknown.svg": 89536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67477;